import React from 'react'

const MenuCard = ({menuData}) => {
  return (
        <>
            <section className='main-card--container'>
                {menuData.map((curElem) => {
                    const { id, name, category, image, description } = curElem;

                    return (
                        <>
                            <div className='card-container' key={id} >
                                <div className='card'>
                                    <div className='card-body'>
                                        <span className='card-number card-circle subtle'>{id}</span>
                                        <span className='card-author subtle'>{category}</span>
                                        <h2 className='card-title'>{name}</h2>
                                        <span className='card-description subtle'>
                                            {description}
                                        </span>
                                        <div className='card-read'>Read</div>
                                    </div>
                                    <img src={image} alt="images" className='card-media' />
                                    <span className='card-tag'>Order Now</span>
                                </div>
                            </div>
                            
                        </>
                    )
                })}
            </section>
            <section className='footer'>
                <div className='contact-icons'>
                    <div>
                        <p>
                        <i class="fa-solid fa-location-dot"></i>Rajasthan, India
                        </p>
                    </div>

                    <div>
                        <p>
                            <i class="fa-solid fa-phone"></i>
                            <a href="tel:">+91 0000000000</a>
                        </p>
                    </div>
                                    
                    <div>
                        <p>
                            <i class="fa-solid fa-envelope"></i>
                            <a href="mailto:">desiitaliano123test@gmail.com</a>
                        </p>
                    </div>
                </div>
            </section>
        </>
  )
}

export default MenuCard